import { OnInit, OnDestroy, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { PopupEventsEmitter } from '../../../events/popup.events';
import { Position } from '../../../enums/position.enum';
var PopupComponent = /** @class */ (function () {
    function PopupComponent(popupEventsEmitter, changeDetectorRef) {
        this.popupEventsEmitter = popupEventsEmitter;
        this.changeDetectorRef = changeDetectorRef;
        this.desktopMaxWidth = '410px';
        this.mobileMaxWidth = '160px';
        this.mobileWidth = 576;
        this.position = Position;
        this.subscriptions = [];
    }
    PopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscriptions.push(this.popupEventsEmitter.popupChanged$
            .subscribe(function (popup) {
            _this.popup = popup;
            if (!_this.popup.maxWidth) {
                _this.popup.maxWidth = _this.desktopMaxWidth;
            }
            if (window.innerWidth <= _this.mobileWidth) {
                _this.popup.maxWidth = _this.mobileMaxWidth;
            }
            _this.changeDetectorRef.detectChanges();
        }));
    };
    PopupComponent.prototype.ngAfterViewInit = function () {
        this.popupEventsEmitter.broadcastPopupComponentViewInitialized(this.wrapper.nativeElement);
    };
    PopupComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (s) { return s.unsubscribe; });
    };
    PopupComponent.prototype.onCancel = function () {
        this.popupEventsEmitter.broadcastPopupCancelClicked();
    };
    PopupComponent.prototype.onSaveChanges = function () {
        this.popupEventsEmitter.broadcastPopupSaveChangesClicked();
    };
    PopupComponent.prototype.onClick = function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (this.popup.closeUponSelection) {
            this.popupEventsEmitter.broadcastPopupCancelClicked();
        }
    };
    Object.defineProperty(PopupComponent.prototype, "axisPosition", {
        get: function () {
            if (this.popup) {
                return this.popup.arrowPosition.slice().pop();
            }
        },
        enumerable: true,
        configurable: true
    });
    return PopupComponent;
}());
export { PopupComponent };
